module.exports = __webpack_public_path__ + "img/community1@2x.741b3bc5.png";